/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { NzModalService } from 'ng-zorro-antd/modal';

import { JsAcceptDialogComponent, NotificationComponent } from '../../../shared/components';

import {
  AppOptionsService,
  AuthService,
  BaseSourceService,
  DynamicFormService,
  ErrorsHandlingService,
  NotificationService
} from '../../../core/services';
import { getModifiedEndpointList, transformArray } from '../../../core/helpers';
import { RtbConnectionMode } from '../../../core/enum';
import { HelpersInterface } from '../../../core/interfaces';
import {
  CompanyInterface,
  PartnerInterfaceGlobal,
  PlatformInterface
} from '../../../core/models';
import {
  checkboxesRTB,
  jsCheckboxes,
  macrosListApp,
  macrosListGoogleAds,
  macrosListMobup,
  macrosListScriptWeb,
  macrosListServerWeb,
  preBidCheckboxes,
  removedJsFields,
  removedPreBidFields,
  removedRTBFields,
  removedVastFields,
  urlAttrsSSP,
  vastCheckboxes
} from '../../../core/constants';

import { CompaniesNewComponent, CompaniesTestLinkComponent } from '../../companies/modals';

import {
  allowCountriesTriggerForSSPModal,
  connectionsForSSPModal,
  apiLinkValidationStatus,
  fraudItemsForSSPModal,
  impTriggeringItems,
  initializeArrayOfMargins,
  initializeVast,
  defaultMacrosListVast,
  marginKeys,
  pubWritingItemsForSSPModal,
  requiredFieldsForSSPModal,
  requiredMacrosForSSPModal,
  sizesListForSSPModal,
  urlVastAttributes,
  MainDashboardInterface,
  DEFAULT_MIMES_ITEMS,
  SKIP_ITEMS,
  STARTDELAY_ITEMS,
  PLACEMENT_ITEMS,
  PLCMT_ITEMS,
  POSITION_ITEMS,
  PLAYBACKMETHOD_ITEMS,
  PROTOCOLS_ITEMS,
  API_PROTOCOLS_ITEMS,
  MIMES_AUDIO_ITEMS,
} from '../models';
import { MainService } from './main.service';
import { EndpointLinkDialogComponent, PrebidEndpointDialogComponent } from '../modals';
import { ErrorValidator } from '../../../core/validators';

interface MacrosItem {
  showAttr: number; // Assuming showAttr is a number based on your usage
  macros: string;
  shortcut: string;
  mobileWeb: boolean;
  desktop: boolean;
  inApp: boolean;
  ctv: boolean;
  // Add other properties as needed
}

@Injectable({
  providedIn: 'root'
})
export class CreateSspService {
  public newSSPForm: FormGroup;
  public formHeight = 'auto';
  public selectedServer = null;
  public selectedAdapters = 0;
  public adServerMacroses: MacrosItem[] = [];
  public seat = '';
  private url: string;
  public protocol: string;
  public token = '';
  public endpointUrl = '';
  public apiLink = '';

  public skipItems = SKIP_ITEMS;
  public startDelayItems = STARTDELAY_ITEMS;
  public placementItems = PLACEMENT_ITEMS;
  public plcmtItems = PLCMT_ITEMS;
  public positionItems = POSITION_ITEMS;
  public playbackmethodItems = PLAYBACKMETHOD_ITEMS;
  public protocolsItems = PROTOCOLS_ITEMS;
  public apiProtocolsItems = API_PROTOCOLS_ITEMS;
  public mimesItems = DEFAULT_MIMES_ITEMS;

  public isActive = false;
  public isRequiredAdFormat = false;
  public isRequiredTrafficType = false;
  public isRequiredCompany = false;
  public isRequiredRegion = false;
  public isShowFields = false;
  public isDisabledTest = false;
  public isDisableSubmit = false;

  public partnerSettings: PartnerInterfaceGlobal.IPartnerSettings;

  public sizesList: { id: number, name: string }[] = sizesListForSSPModal;
  public apiLinkValidationStatus = apiLinkValidationStatus;

  public allowCountriesTrigger = allowCountriesTriggerForSSPModal;

  public fraudItems = fraudItemsForSSPModal;

  public pubWritingItems = pubWritingItemsForSSPModal;


  public listOfMacros: MainDashboardInterface.IVastMacros[] = [];
  public selectedJsMacros: string[] = [];
  public companiesDSPDropdown: HelpersInterface.ITressSelectItem[] = [];
  public macrosListJs: { id: string, name: string, desc: string }[] = [];
  public adaptersItem: PlatformInterface.IRtbAdaptersItem;
  public iabBlockedCategories: HelpersInterface.ITressSelectItem[] = [];
  public iabCategories: HelpersInterface.ITressSelectItem[] = [];
  public dspList: PlatformInterface.IPlatformDSP[] = [];
  public companies: CompanyInterface.ICompany[] = [];
  public regions: { id: string, name: string }[] = [];
  public rtbAdapters: { id: number | string; name: string, config, disabled: boolean }[] = [];
  public adaptersRtb: { name: string, field: string | number, id: string, config, tooltip?: string; }[] = [];
  public listOfSizes: { id: number, width: number, height: number, name: string }[] = [];
  public categories: { id: string; name: string }[] = [];

  public macrosListVast = defaultMacrosListVast;

  public RtbConnectionMode = RtbConnectionMode;

  public vast = initializeVast;

  private requiredFields = requiredFieldsForSSPModal;

  private endpoint: PlatformInterface.IPlatformSSP;

  private urlAttrs = urlAttrsSSP;
  private macrosListScriptWeb: { id: string, name: string, desc: string }[] = macrosListScriptWeb;
  private macrosListApp: { id: string, name: string, desc: string }[] = macrosListApp;
  private macrosListServerWeb: { id: string, name: string, desc: string }[] = macrosListServerWeb;
  private macrosListGoogleAds: { id: string, name: string, desc: string }[] = macrosListGoogleAds;
  private macrosListMobup: { id: string, name: string, desc: string }[] = macrosListMobup;
  private urlVastAttributes = urlVastAttributes;
  private requiredMacros = requiredMacrosForSSPModal;
  private selectedSizes = '0';

  private rtbServers: PlatformInterface.IRtbAdaptersItem[] = [];
  private adaptersFields: { field: string | number, id: string, config }[] = [];
  private fieldsAdapters: any[] = [];

  private marginKeys = marginKeys;
  private arrayOfMargins: { key: string, minValue: number, maxValue: number }[] = initializeArrayOfMargins;

  private connections = connectionsForSSPModal;

  private adServers = [];

  private selectedAdapterName: string;

  private get adaptersRTB(): string | number | null {
    return this._adaptersRTB;
  }

  private set adaptersRTB(value: string | number | null) {
    this._adaptersRTB = value;
  }

  private get servers() {
    return this._servers;
  }

  private set servers(value) {
    this._servers = value;
  }

  private get partner(): PartnerInterfaceGlobal.IPartnerGeneral {
    return this._partner;
  }

  private set partner(value: PartnerInterfaceGlobal.IPartnerGeneral) {
    this._partner = value;
  }

  public impTriggeringItems = impTriggeringItems;

  private companyFilter: {
    connectionType: string,
    setting: string
  };
  private selectedMacrosesCache: string[] = [];
  private _connectionType = 'rtb';
  private _isShowPartnerNameForPrebid = true;
  private _isShowPartnerNameForPrebidJS = true;
  private _hasScanner: boolean;

  private _adaptersRTB: string | number | null = null;
  private _servers = [{ id: null, name: 'Attekmi' }];
  private _partner: PartnerInterfaceGlobal.IPartnerGeneral;

  private apiUrl: string;

  constructor(
    private appOptions: AppOptionsService,
    private auth: AuthService,
    private modalService: NzModalService,
    private notificationService: NotificationService,
    private notificationComponent: NotificationComponent,
    private baseSourceService: BaseSourceService,
    private dynamicFormService: DynamicFormService,
    private errorsHandlingService: ErrorsHandlingService,
    private mainService: MainService,
    private http: HttpClient,
  ) {
    this.hasScanner = this.baseSourceService.hasScanner;
    this.apiUrl = this.appOptions.getApiUrl();
  }

  public get hasScanner(): boolean {
    return this._hasScanner;
  }

  public set hasScanner(value: boolean) {
    this._hasScanner = value;
  }

  public get isPartnerPlanBasic(): boolean {
    return this.partner?.partner_plan === 3;
  }

  public isShowSkipFields(): boolean {
    return this.formValue.vast.skip === 1;
  }

  public restrictionTooltipMessage(field: string): string {
    return (this.partner?.partner_plan !== 1 && this.partner?.partner_plan !== 2) ? `${field} is available on Plus and Enterprise versions.
    If you want to upgrade your platform, please contact our Business Development Manager` : '';
  }

  public restrictionTooltipForVastExtensions(): string {
    return this.partner?.partner_plan !== 1 ? 'VAST Extensions are available on Enterprise version. If you want to upgrade your platform, please contact our Business Development Manager' : '';
  }

  public createForm(): void {
    this.newSSPForm = this.dynamicFormService.createSSPForm();
    this.formControls['name'].addValidators([ErrorValidator.cannotContainSpace]);

    if (this.partner?.partner_plan === 3) {
      this.formControls['has_demand_booster'].disable({ emitEvent: false });
      this.formControls['has_maximised_bidprice'].disable({ emitEvent: false });
    }

    this.updateControlsBasedOnPartnerPlan();
  }

  public getIsRequiredAdapterField(itemName: string): boolean {
    const config = this.adaptersItem.config;

    if (this.isConfigValid(config)) {
      return config.paramsReq[itemName]?.required ?? false;
    }

    return false;
  }

  public initializeData(data: MainDashboardInterface.ICreateSSPDialog) {
    this.setPartner();
    this.createForm();
    this.connectionType = 'rtb';
    this.fetchOptions(data);
    this.setupConfigurations();
    this.initializeCompanyFilter();
    this.fetchAdditionalData();
    this.getCompaniesForDropdowns(this.formValue.region);
  }

  public get isSizeRequired(): boolean {
    return this.selectedSizes === '0';
  }


  public get adTypeControlValue(): string {
    return this.newSSPForm.get('adtype')?.value;
  }

  public get isShowImpTriggering(): boolean {
    return ['rtb', 'prebid', 'prebidJs'].includes(this.connectionType);
  }

  public get jsTagType(): string {
    return this.newSSPForm.get('js')?.get('tagType')?.value;
  }

  public get isShowDemandBooster(): boolean {
    if (this.isJSConnection()) {
      return true;
    } else if (!this.isVastConnection() && this.formValue['isBanner']) {
      return true;
    } else {
      return false;
    }
  }

  public getTooltipForHuaweiAdapter(name: string): string {
    return name === 'Huawei' && !this.isOnlyNativeSelected()
      ? 'Available only with the Native ad format' :
      '';
  }

  public get isShowVastSizesControls(): boolean {
    return this.formValue.vast.selectedSizes === 1;
  }

  public isShowStartDelayMidControls(): boolean {
    return this.formValue.vast.startdelay === 1;
  }

  public get connectionType(): string {
    return this._connectionType;
  }

  public set connectionType(value: string) {
    this._connectionType = value;
  }

  public get formValue() {
    return this.newSSPForm.value;
  }

  public onChangeVastEndpointHandler(vastEndpoint: string): void {
    this.formControls['endpoint'].patchValue(vastEndpoint);
  }

  public onChangeVastMacrosListHandler(macrosList: string[]): void {
    this.vast.macrosList = macrosList;

    this.getVastMacroses();
  }

  public isBotmanPreBidIsEnabled() {
    return !!this.auth.partner.botman_settings?.enable_prebid;
  }

  public isBotmanPostBidIsEnabled() {
    return !!this.auth.partner.botman_settings?.enable_postbid;
  }

  public isFraudSensorEnabled(): boolean {
    return !!this.partnerSettings.use_fraud_sensor;
  }

  public isMediaGuardEnabled(): boolean {
    return !!this.partnerSettings.use_media_guard;
  }

  public isFraudLogixEnabled(): boolean {
    return !!this.partnerSettings.useFraudlogix;
  }

  public isPartnerNovoroll() {
    return this.auth.partner.id === 76;
  }

  public onChangeActiveHandler(value: boolean): void {
    this.activeControl.patchValue(value);
  }

  public onChangePixalatePreBidIpHandler(value: any): void {
    if (!value) {
      this.formControls['pixalate_pb_settings']?.get('ip_percent')?.patchValue(0, { emitEvent: false });
    }
  }

  public onChangePixalatePreBidIFAHandler(value: any): void {
    if (!value) {
      this.formControls['pixalate_pb_settings']?.get('ifa_percent')?.patchValue(0, { emitEvent: false });
    }
  }

  public onChangePixalatePreBidBundleHandler(value: any): void {
    if (!value) {
      this.formControls['pixalate_pb_settings']?.get('hr_app_percent')?.patchValue(0, { emitEvent: false });
    }
  }

  public onEndpointRegionChangeHandler(region: string): void {
    this.isRequiredRegion = !this.formControls['region'].value;

    if (this.isRequiredRegion || !this.partnerSettings?.domains?.length) {
      return;
    }

    const found = this.partnerSettings.domains.find(({ region: r }) => r === region);
    if (!found) {
      return;
    }

    this.partnerSettings.ns = found.ns;
    this.onChangeMacrosHandler(this.selectedJsMacros);

    this.getCompaniesForDropdowns(region);
  }

  public onChangeVideoFormatHandler(enableVideo: boolean): void {
    this.formControls['isVideo'].patchValue(enableVideo, { emitEvent: false });
    if (!this.isVastConnection()) {
      return;
    }

    if (enableVideo) {
      this.macrosListVast = this.macrosListVast.filter(({ id }) => id !== '[FEED]');
      this.vast.macrosList = this.vast.macrosList.filter(macro => macro !== '[FEED]');

      this.formControls['vast']?.get('mimes')?.patchValue([
        'video/mp4',
        'video/mpeg',
        'video/ogg',
        'video/webm',
        'application/javascript'
      ]);
    } else {
      this.macrosListVast = [...defaultMacrosListVast];
    }

    this.listOfMacros = [...this.macrosListVast];

    this.updateControlsBasedOnPartnerPlan();
  }

  public onChangeAudioFormatHandler(enableAudio: boolean): void {
    this.formControls['isAudio'].patchValue(enableAudio, { emitEvent: false });
    if (enableAudio) {
      this.formControls['vast']?.get('mimes')?.patchValue(['audio/mp4']);
      this.mimesItems = MIMES_AUDIO_ITEMS;
    } else {
      this.formControls['vast']?.get('mimes')?.patchValue([
        'video/mp4',
        'video/mpeg',
        'video/ogg',
        'video/webm',
        'application/javascript'
      ]);
      this.mimesItems = DEFAULT_MIMES_ITEMS;
    }

    this.updateControlsBasedOnPartnerPlan();
  }

  public onChangeRewardedFormatHandler(enableRewarded: boolean): void {
    this.formControls['rewarded'].patchValue(enableRewarded, { emitEvent: false });
    this.updateControlsBasedOnPartnerPlan();
  }

  public onTagTypeChangeHandler(type: string): void {
    this.updateTagType(type);
    if (type === 'direct') {
      this.handleDirectType();
    } else {
      this.handleOtherTypes(type);
      this.removeUserIdMacro(type);
    }
    this.updateMacrosList();
  }

  private updateTagType(type: string): void {
    this.newSSPForm.get('js')?.get('tagType')?.patchValue(type);
  }

  private handleDirectType(): void {
    this.selectedMacrosesCache = [...this.selectedJsMacros];
    this.selectedJsMacros = [];
  }

  private handleOtherTypes(type: string): void {
    this.selectedJsMacros = this.selectedMacrosesCache.length > 0 ? [...this.selectedMacrosesCache] : [];
    const macrosMap = {
      'web': this.macrosListScriptWeb,
      'app': this.macrosListApp,
      'serverApp': this.macrosListApp,
      'serverWeb': this.macrosListServerWeb,
      'googleAd': this.macrosListGoogleAds,
      'mobup': this.macrosListMobup
    };
    const selectedList = macrosMap[type] || [];
    this.selectedJsMacros = selectedList.map(m => m.id);
  }

  private removeUserIdMacro(type: string): void {
    if (['web', 'app', 'serverApp', 'serverWeb'].includes(type)) {
      const userIdIndex = this.selectedJsMacros.indexOf('[USER_ID]');
      if (userIdIndex !== -1) {
        this.selectedJsMacros.splice(userIdIndex, 1);
      }
    }
  }

  private updateMacrosList(): void {
    this.macrosListJsControl.patchValue(this.selectedJsMacros);
    this.onChangeMacrosHandler(this.selectedJsMacros);
  }

  public onSubmitForm(callback: (type: string) => void): void {
    if (!this.checkModalTransitionAndErrors()) {
      return;
    }

    const dspList = this.getDSPList();
    this.executeSubmitAction(dspList, callback);
  }

  private checkModalTransitionAndErrors(): boolean {
    if (!this.handleErrors()) {
      this.isDisableSubmit = false;
      return false;
    }
    return true;
  }

  private getDSPList(): any[] {
    return getModifiedEndpointList(this.companiesDSPDropdown);
  }

  private executeSubmitAction(dspList: any[], callback: (type: string) => void): void {
    const submitActions = {
      'rtb': this.onSubmitRtb,
      'vast': this.onSubmitVast,
      'prebid': this.onSubmitPreBid,
      'prebidJs': this.onSubmitPreBid,
      'js': this.onSubmitJS
    };

    const action = submitActions[this.connectionType];
    if (action) {
      action.call(this, this.connections[this.connectionType], dspList, callback);
    }
  }

  public onCloseModal(callback: (type: string) => void): void {
    this.isActive = false;
    this.newSSPForm.reset();
    callback('cancel');
  }

  public onPreventInputHandler(event: Event, field: string): void {
    const value = this.pixalatePreBidSettingsControls[field].value;

    if (value > 100) {
      event.preventDefault();

      return this.pixalatePreBidSettingsControls[field].patchValue(parseInt(value.toString().substring(0, 2)));
    }

    if (value < 0) {
      event.preventDefault();

      return this.pixalatePreBidSettingsControls[field].patchValue(0);
    }
  }

  public onCompanyChangeHandler(val: number): void {
    this.updateIsRequiredCompany();

    if (val === -1) {
      this.openNewCompanyModal();
    }
  }

  private updateIsRequiredCompany(): void {
    // Simplifies the check for companyId's value
    this.isRequiredCompany = this.formControls['companyId'].value == null;
  }

  private openNewCompanyModal(): void {
    const dialogRef = this.modalService.create({
      nzContent: CompaniesNewComponent,
      nzFooter: null,
      nzMaskClosable: false,
      nzClosable: false,
      nzClassName: 'companies-new-modal',
      nzWrapClassName: 'companies-new-modal-wrap',
      nzStyle: { top: '100px', width: '650px' },
      nzBodyStyle: { width: '650px', padding: '0px', height: '335px' },
    });

    this.handleModalClose(dialogRef);
  }

  private handleModalClose(dialogRef: any): void {
    dialogRef.afterClose.subscribe((data: { status: string, data: CompanyInterface.ICompany }) => {
      if (data.status === 'success') {
        this.handleSuccess(data.data);
      } else if (data.status === 'cancel') {
        this.handleCancel();
      }
    });
  }

  private handleSuccess(companyData: CompanyInterface.ICompany): void {
    this.companies.push(companyData);
    this.formControls['companyId'].patchValue(companyData.id);
  }

  private handleCancel(): void {
    this.isRequiredCompany = true;
    this.formControls['companyId'].patchValue(null);
  }

  public async onApiLinkTestHandler(link: string, e: Event): Promise<void> {
    e.preventDefault();
    const resp = await this.mainService.testApiLink(link);
    this.modalService.create({
      nzMaskClosable: false,
      nzContent: CompaniesTestLinkComponent,
      nzData: {
        apitest: resp,
      }
    });
    return;
  }

  public onValidateLinkHandler(link: string, event: Event): void {
    event.preventDefault();
    this.apiLink = link;
    this.isDisabledTest = false;
  }

  public getError(value: boolean): void {
    this.isDisabledTest = value;
  }

  public onChangeConnectionTypeHandler(value: any): void {
    this.connectionType = value;
    this.companyFilter.connectionType = value;

    // Reset form controls for certain connection types
    const resetControls = ['isVideo', 'isAudio', 'isBanner', 'rewarded', 'isNative', 'popRespXml'];
    const resetValues = resetControls.reduce((acc, control) => ({ ...acc, [control]: false }), {});
    const connectionTypesWithReset = ['rtb', 'prebid', 'prebidJs'];
    if (connectionTypesWithReset.includes(this.connectionType)) {
      Object.entries(resetValues).forEach(([control, value]) => this.formControls[control].patchValue(value, { emitEvent: false }));
    }

    if (this.isVastConnection()) {
      this.newSSPForm.get('adtype')?.patchValue('mobile_web');

      this.updateControlsBasedOnPartnerPlan();
    }

    // Special handling for JS connection types
    if (this.isJSConnection()) {
      this.handleJSConnectionType();
    }

    this.getCompaniesNames();

    this.companyFilter = {
      connectionType: this.connectionType,
      setting: 'ssp'
    };
  }

  private isConfigValid(config: any): boolean {
    return config && !Array.isArray(config) && Object.keys(config).length > 0;
  }

  private handleJSConnectionType(): void {
    const dialogRef = this.modalService.create({
      nzContent: JsAcceptDialogComponent,
      nzClosable: false,
      nzMaskClosable: false,
      nzCentered: true,
      nzKeyboard: false,
      nzClassName: 'js-accept-modal',
      nzWrapClassName: 'js-accept-modal-wrap',
      nzStyle: { width: '650px', height: 'auto' },
      nzBodyStyle: { width: '650px', padding: '0px', height: 'auto' },
      nzData: {
        side: 'ssp',
      }
    });

    dialogRef.afterClose.subscribe(res => {
      if (res.action === 'cancel') {
        this.connectionTypeControl.patchValue('rtb', { emitEvent: false });
        this.onChangeConnectionTypeHandler('rtb');
      } else if (res.action === 'accept') {
        this.resetFormControls();
        this.updateMacrosBasedOnJsTagType();
      }
    });
  }

  private resetFormControls(): void {
    const controlsToReset = ['isVideo', 'isAudio', 'isBanner', 'rewarded', 'isNative', 'popRespXml'];
    controlsToReset.forEach(control => this.formControls[control].patchValue(undefined, { emitEvent: false }));
    this.selectedJsMacros = [];
  }

  private updateMacrosBasedOnJsTagType(): void {
    const tagTypeToMacroListMap = {
      'direct': [],
      'web': this.macrosListScriptWeb,
      'app': this.macrosListApp,
      'serverApp': this.macrosListApp,
      'serverWeb': this.macrosListServerWeb,
      'googleAd': this.macrosListGoogleAds,
      'mobup': this.macrosListMobup
    };

    const excludedIds = new Set([
      '[USER_ID]', '[DESCRIPTION_URL]', '[APP_VERSION]', '[BUYER_UID]',
      '[IFA_TYPE]', '[LANGUAGE]', '[PLACEMENT_ID]', '[TITLE]', '[GPP]', '[MIMES]'
    ]);

    const selectedList = tagTypeToMacroListMap[this.jsTagTypeFormControl.value] || [];
    this.selectedJsMacros = selectedList.map(m => m.id).filter(id => !excludedIds.has(id));
    this.macrosListJs = selectedList;
    this.macrosListJsControl.patchValue(this.selectedJsMacros);
    this.onChangeMacrosHandler(this.selectedJsMacros);
  }

  public onChangeDemandBoosterValueHandler(value: boolean, element: string): void {
    if (element === 'isBanner' && value === false) {
      this.formControls['has_demand_booster'].patchValue(false);
    }

    if (this.isRtbConnection()) {
      this.onSetHuaweiAdapterByAdFormat();
    }
  }

  public onChangeBCATCheckboxStateHandler(value: boolean): void {
    switch (value) {
      case true:
        break;
      default:
        this.formControls['iab_bcat'].patchValue([]);
        break;
    }
  }

  public onChangeIABCategoriesCheckboxStateHandler(value: boolean): void {
    switch (value) {
      case true:
        break;
      default:
        this.formControls['iab_cat'].patchValue([]);
    }
  }

  public onChangeCustomAdaptersHandler(server: string | number): void {
    if (server === null) return;

    this.resetAdaptersFields();
    this.findAdapterItem(server);
    this.configureAdaptersRtb();
    this.updateVisibility();
    this.setAdaptersRTB(server);
  }

  private resetAdaptersFields(): void {
    this.adaptersFields = [];
  }

  private findAdapterItem(server: string | number): void {
    const adaptersItem = this.rtbServers.find(item => item.id === server);
    if (adaptersItem) {
      this.adaptersItem = adaptersItem;
      this.selectedAdapterName = adaptersItem.name;
    }
  }

  private configureAdaptersRtb(): void {
    this.adaptersRtb = this.adaptersItem?.fields.length > 0
      ? this.adaptersItem.fields.map(field => this.mapFieldToAdapter(field))
      : [];
  }

  private mapFieldToAdapter(field: string): any {
    return { name: field, field: '', id: field, config: field, tooltip: this.adaptersItem.config.paramsReq[field]?.tooltip ?? null };
  }

  private updateVisibility(): void {
    this.isShowFields = this.adaptersRtb.length > 0;
  }

  private setAdaptersRTB(server: string | number): void {
    this.adaptersRTB = server;
  }

  public onChangeAdapterFieldHandler(_: Event) {
    this.isDisableSubmit = false;
  }

  public onChangeAdTypeHandler() {
    this.selectedServer = null;
    this.servers = [{ id: null, name: 'Attekmi' }]
      .concat(this.adServers.filter((item: any) => item.adTypes[this.adTypeControlValue])
        .map(({ id, name }) => ({ id, name })));

    this.setSelectedMacrosList();
  }

  public onChangeMarginTypeHandler(type: string): void {
    this.changeStatusForBidPriceControl(type);
    this.resetMargins();
    const marginType = this.formControls.margin_type.value;
    if (marginType === 'range') {
      this.handleRangeMargin();
    } else if (marginType === 'fixed') {
      this.handleFixedMargin();
    } else if (marginType === 'adaptive') {
      this.handleAdaptiveMargin();
    }
  }

  private resetMargins(): void {
    this.arrayOfMargins = [];
    this.formControls.margin.patchValue(undefined);
    this.formControls.min_margin.patchValue(undefined);
    this.formControls.max_margin.patchValue(undefined);
  }

  private handleRangeMargin(): void {
    this.arrayOfMargins = [
      { key: 'min_margin', minValue: 1, maxValue: 100 },
      { key: 'max_margin', minValue: 1, maxValue: 100 }
    ];
  }

  private handleFixedMargin(): void {
    this.arrayOfMargins = [{ key: 'margin', minValue: 0, maxValue: 100 }];
  }

  private handleAdaptiveMargin(): void {
    this.resetMargins();
  }

  private changeStatusForBidPriceControl(type: string): void {
    if (type !== 'fixed') {
      this.formControls['has_maximised_bidprice'].patchValue(false);
      this.formControls['has_maximised_bidprice'].disable();
    } else {
      this.formControls['has_maximised_bidprice'].patchValue(false);
      this.formControls['has_maximised_bidprice'].enable();
    }
  }

  public isVastConnection() {
    return this.connectionType === 'vast';
  }

  public isRtbConnection() {
    return this.connectionType === 'rtb';
  }

  public isPreBidConnection() {
    return this.connectionType === 'prebid';
  }

  public isJSConnection(): boolean {
    return this.connectionType === 'js';
  }

  public isPrebidJsConnection(): boolean {
    return this.connectionType === 'prebidJs';
  }

  public onChangeDefaultBidfloorHandler() {
    this.formControls.fixedPrice.patchValue(this.formControls.defaultBidfloor.value > 0);
  }

  public onChangeSizeHandler(id: number): void {
    const elementSize = id ? this.listOfSizes.find(element => element.id === id) : { width: null, height: null };
    this.jsWidthControl.patchValue(elementSize?.width);
    this.jsHeightControl.patchValue(elementSize?.height);
  }

  public onValidateSpaceForNameHandler() {
    const nameControl = this.formControls['name'];
    if (nameControl.errors?.whitespace) {
      this.showNotificationError('error', 'error', 'error', 'Name cannot start with whitespace');
    }
  }

  public onChangeMacrosHandler(selectedItems: string[]) {
    this.selectedJsMacros = this.uniqueMacros(this.getMandatoryMarcoses().concat(selectedItems));
    if (!this.isJSConnection()) return;

    this.constructUrlBasedOnTagType();
    this.endpointUrl = this.url;
  }

  private fetchOptions(data: MainDashboardInterface.ICreateSSPDialog) {
    this.categories = this.appOptions.getCategoriesForAutologger();
    this.regions = this.appOptions.getRegions(this.auth.partner.regions);
    this.listOfSizes = this.appOptions.getListOfSizes();
    this.companies = data.allCompanies;
    this.partnerSettings = data.partnerSettings;
    this.isRequiredCompany = false;
    this.isRequiredRegion = false;
    this.isRequiredAdFormat = false;
    this.isRequiredTrafficType = false;
    this.isDisabledTest = false;
    this.apiLink = '';
    this.selectedAdapters = 0;
    this.isDisabledTest = false;
    this.apiLink = '';
  }

  private setupConfigurations() {
    this.setEndpointRegion();
    this.setJSMacrosList();
    this.setInitSelectedMacrosList();
    this.getVastMacroses();
    this.setShowStatusForPartnerName();
  }

  private initializeCompanyFilter() {
    this.companyFilter = {
      connectionType: this.connectionType,
      setting: 'ssp'
    };
  }

  private fetchAdditionalData() {
    this.getIABCategories();
    this.getSeatAndTokenForJsTag();
    this.setPartnerDomain();
    this.setProtocolAndURL();
    this.getSSPAdapters();
    this.getDSPEndpoints();
    this.getAdServers();
  }

  private setPartner() {
    this.partner = this.auth.partner;
  }

  private uniqueMacros(macros: string[]): string[] {
    return macros.filter((elem, pos, arr) => arr.indexOf(elem) === pos);
  }

  private constructUrlBasedOnTagType(): void {
    const tagType = this.jsTagTypeFormControl.value;
    const baseTag = '<script type="text/javascript"src="{url}"></script>';
    let tagTemplate = baseTag;
    let urlType = '';

    switch (tagType) {
      case 'web':
      case 'app':
        urlType = 's2c';
        break;
      case 'serverWeb':
      case 'serverApp':
        urlType = 's2s';
        break;
      case 'googleAd':
        urlType = 'dfp';
        tagTemplate = '<script type="text/javascript"src="{url}"></script>';
        break;
      case 'mobup':
        urlType = 'applovin';
        tagTemplate = '<script src="{url}"></script>';
        break;
      default:
        urlType = 'direct';
        tagTemplate = '<script async type="text/javascript"src="{url}"></script>';
        break;
    }

    this.url = this.constructUrl(urlType, tagType);
    this.url = tagTemplate.replace('{url}', this.url);
  }

  private constructUrl(urlType: string, tagType: string): string {
    let url = `https://${this.partnerSettings.ns}/?c=rtb&m=js&type=${urlType}&seat=${this.seat}&token=${this.token}`;

    if (tagType === 'direct') {
      url = `https://${this.partnerSettings.ns}/?c=rtb&m=direct&seat=${this.seat}&token=${this.token}`;
    }

    if (tagType !== 'googleAd') {
      this.selectedJsMacros.forEach(macro => {
        url += `&${this.urlAttrs[macro]}=${macro}`;
      });
    } else {
      this.selectedJsMacros.forEach(macro => {
        url += `${this.urlAttrs[macro]}${macro}`;
      });
    }
    return url;
  }

  private get formControls(): { [key: string]: FormControl } {
    return this.newSSPForm.controls as { [key: string]: FormControl };
  }

  private resolveVast(): {
    bidfloor: any;
    macrosList: any[];
  } {
    return this.vastFormGroupValue;
  }

  private get connectionTypeControl(): FormControl {
    return this.newSSPForm.get('connectionType') as FormControl;
  }

  private get activeControl(): FormControl {
    return this.newSSPForm.get('active') as FormControl;
  }

  private onSubmitRtb(connectionType: number, dspList: number[], callback: (type: string) => void): void {
    this.setDefaultBidfloor();
    this.populateAdaptersFields();
    const fields = this.constructFieldsObject();

    if (!fields) {
      return;
    }

    delete this.formValue.vastConnectionMode;
    this.constructEndpoint();

    const rtbEndpointData = this.constructRtbEndpointData(connectionType, dspList);
    this.createSSPRtbEndpoint(rtbEndpointData, callback);
  }

  private onSubmitVast(connectionType: number, dspList: number[], callback: (type: string) => void): void {
    this.patchVastFormControls();
    delete this.formValue.rtbConnectionMode;

    let vastDataEndpoint = this.constructVastDataEndpoint(connectionType, dspList);

    if (vastDataEndpoint.vast.startdelaymid) {
      delete vastDataEndpoint.vast.startdelaymid;
    }

    vastDataEndpoint = this.removeNonEnterpriseFields(vastDataEndpoint);

    this.createVastSSP(vastDataEndpoint, callback);
  }

  private onSubmitPreBid(connectionType: number, dspList: number[], callback: (type: string) => void): void {
    this.cleanupFormValue();

    const preBidEndpointData = this.constructPreBidEndpointData(connectionType, dspList);
    this.createPreBidSSP(preBidEndpointData, callback);
  }

  private onSubmitJS(connectionType: number, dspList: number[], callback: (type: string) => void): void {
    this.patchAdTypeControls();
    this.patchMacrosListControl();

    delete this.formValue.vastConnectionMode;
    delete this.formValue.rtbConnectionMode;

    const jsDataEndpoint = this.constructJsDataEndpoint(connectionType, dspList);
    this.createJsSSP(jsDataEndpoint, callback);
  }

  private setDefaultBidfloor(): void {
    if (this.formControls['defaultBidfloor'].value == null) {
      this.formControls['defaultBidfloor'].patchValue(0);
    }
  }

  private populateAdaptersFields(): void {
    this.adaptersRtb.forEach(item => {
      this.adaptersFields.push({ field: item.field, id: item.id, config: item.config });
    });
  }

  private constructFieldsObject(): any {
    let fields = {};
    this.fieldsAdapters = [];
    if (this.adaptersFields.length === 0) {
      this.fieldsAdapters = [];
      return fields;
    }

    this.adaptersFields.forEach(value => {
      fields[value.id] = value.field;
    });

    this.fieldsAdapters.push(fields);

    if (!this.validateFields(fields)) {
      return false;
    }

    return fields;
  }

  private validateFields(fields: any): boolean {
    for (const field in fields) {
      if (this.adaptersItem.config.paramsReq[field].required && (fields[field] === null || fields[field].length === 0)) {
        this.showNotificationError('error', 'error', 'error', `${field} is required`);
        return false;
      }
    }

    return true;
  }

  private buildAdapterConfig(): any {
    const fields: any = {};
    this.fieldsAdapters = [];
    if (this.adaptersFields.length === 0) {
      this.fieldsAdapters = [];
      return;
    }

    this.adaptersFields.forEach(value => {
      fields[value.id] = value.field;
    });
    this.fieldsAdapters.push(fields);
    return fields;
  }

  private constructEndpoint(): void {
    this.endpoint = {
      ...this.formValue,
      adapter_id: this.selectedAdapters,
      connectionType: 0,
      active: this.formValue.active,
    };
  }

  private constructRtbEndpointData(connectionType: number, dspList: number[]): any {
    return {
      ...this.formValue,
      connectionType: connectionType,
      iab_bcat: [...this.getCheckedBlockedIABCategories()],
      iab_cat: [...this.getCheckedIABCategories()],
      adapter_id: this.endpoint.adapter_id,
      adapter_config: this.adaptersFields.length > 0 ? this.buildAdapterConfig() : null,
      dspList: dspList,
    };
  }

  private createSSPRtbEndpoint(rtbEndpointData: any, callback: (type: string) => void): void {
    this.mainService.createNewSSP(this.modifyReqData(removedRTBFields, checkboxesRTB, rtbEndpointData))
      .subscribe((resp: PlatformInterface.IUpdateSSPResponse) => {
        callback('created');
        this.isActive = false;
        this.newSSPForm.reset();
        this.connectionType = 'rtb';
        this.modalService.create({
          nzContent: EndpointLinkDialogComponent,
          nzMaskClosable: false,
          nzClassName: 'endpoint-link-modal',
          nzWrapClassName: 'endpoint-link-modal-wrap',
          nzStyle: { top: '100px', width: '600px', height: 'auto' },
          nzBodyStyle: { width: '600px', padding: '0px', height: 'auto' },
          nzClosable: false,
          nzData: {
            endpoint: resp.data.endpoint,
            name: resp.data.name
          }
        });
      }, err => {
        this.errorsHandlingService.handleError(err);
        this.isDisableSubmit = false;
      });
  }

  private patchVastFormControls(): void {
    const controlValues = {
      'ctv': this.adTypeControlValue === 'ctv',
      'mobile_web': this.adTypeControlValue === 'mobile_web',
      'desktop': this.adTypeControlValue === 'desktop',
      'mobile_app': this.adTypeControlValue === 'mobile_app'
    };

    Object.entries(controlValues).forEach(([controlName, value]) => {
      const control = this.formControls?.[controlName];
      if (control) {
        control.patchValue(value);
      }
    });

    // Patch vast connection mode if control exists
    const vastModeControl = this.newSSPForm.get('vastConnectionMode');
    if (vastModeControl) {
      const currentMode = (this as any).vastConnectionMode;
      const vastConnections = (this as any).vastConnections;
      const mappedMode = vastConnections && currentMode ? vastConnections[currentMode] : currentMode;
      if (mappedMode != null) {
        vastModeControl.patchValue(mappedMode);
      }
    }

    this.vastFormGroup?.get('macrosList')?.patchValue(this.vast?.macrosList ?? []);
  }

  private constructVastDataEndpoint(connectionType: number, dspList: number[]): any {
    return {
      ...this.formValue,
      ...this.resolveVast(),
      connectionType: connectionType,
      iab_cat: [...this.getCheckedIABCategories()],
      dspList: dspList,
      seat: this.seat,
      secretKey: this.token,
      vast: {
        ...this.formValue.vast,
        startdelay: this.formValue.vast.startdelay === 1 ? this.formValue.vast.startdelaymid : this.formValue.vast.startdelay,
        is_rewarded: !this.formValue['rewarded'] ? undefined : this.formValue.vast.is_rewarded ? 1 : 0
      }
    };
  }

  private createVastSSP(vastDataEndpoint: any, callback: (type: string) => void): void {
    this.mainService.createNewSSP(this.modifyReqData(removedVastFields, vastCheckboxes, vastDataEndpoint))
      .subscribe(() => {
        this.showNotificationError('success', 'success', 'success', 'The endpoint successfully generated');
        callback('created');
        this.isActive = false;
        this.newSSPForm.reset();
        this.connectionType = 'rtb';
      }, error => {
        this.errorsHandlingService.handleError(error);
        this.isDisableSubmit = false;
      });
  }

  private cleanupFormValue(): void {
    delete this.formValue.vastConnectionMode;
    delete this.formValue.rtbConnectionMode;
  }

  private constructPreBidEndpointData(connectionType: number, dspList: number[]): any {
    return {
      ...this.formValue,
      iab_bcat: [...this.getCheckedBlockedIABCategories()],
      iab_cat: [...this.getCheckedIABCategories()],
      connectionType: connectionType,
      dspList: dspList,
    };
  }

  private createPreBidSSP(preBidEndpointData: any, callback: (type: string) => void): void {
    this.mainService.createNewSSP(this.modifyReqData(removedPreBidFields, preBidCheckboxes, preBidEndpointData))
      .subscribe((resp: PlatformInterface.IUpdateSSPResponse) => {
        this.openPreBidDialog(resp);
        callback('created');
        this.isActive = false;
        this.newSSPForm.reset();
        this.connectionType = 'rtb';
      }, err => {
        this.errorsHandlingService.handleError(err);
        this.isDisableSubmit = false;
      });
  }

  private openPreBidDialog(resp: PlatformInterface.IUpdateSSPResponse): void {
    const { partnerName, seat, token } = this.extractPreBidDialogData(resp.data);
    this.modalService.create({
      nzContent: PrebidEndpointDialogComponent,
      nzMaskClosable: false,
      nzClassName: 'endpoint-link-modal',
      nzWrapClassName: 'endpoint-link-modal-wrap',
      nzStyle: { top: '100px', width: '600px', height: '300px' },
      nzBodyStyle: { width: '600px', padding: '0px', height: '300px' },
      nzClosable: false,
      nzData: {
        connectionType: this.connectionTypeControl.value,
        isShowPartnerNameForPrebid: this.isShowPartnerNameForPrebid,
        isShowPartnerNameForPrebidJS: this.isShowPartnerNameForPrebidJS,
        name: resp.data.name,
        partnerName: partnerName,
        seat: seat,
        token: token,
        endpoint: resp.data.endpoint
      }
    });
  }

  private extractPreBidDialogData(data: any): { partnerName: string, seat: string, token: string } {
    const partnerName = data.prebid_params ? data.prebid_params.name : '';
    const seat = data.endpoint.substring(data.endpoint.lastIndexOf('seat=') + 5, data.endpoint.lastIndexOf('&'));
    const token = data.endpoint.substring(data.endpoint.lastIndexOf('&') + 7);
    return { partnerName, seat, token };
  }

  private patchAdTypeControls(): void {
    const adTypeMappings = {
      'mobile_web': 'mobile_web',
      'desktop': 'desktop',
      'mobile_app': 'mobile_app'
    };

    Object.entries(adTypeMappings).forEach(([adType, formControlKey]) => {
      this.formControls[formControlKey].patchValue(this.adTypeControlValue === adType ? 1 : 0);
    });
  }

  private patchMacrosListControl(): void {
    const macrosMappings = {
      'web': this.macrosListScriptWeb,
      'app': this.macrosListApp,
      'serverApp': this.macrosListApp,
      'serverWeb': this.macrosListServerWeb,
      'googleAd': this.macrosListGoogleAds,
      'mobup': this.macrosListMobup
    };

    const selectedMacrosList = macrosMappings[this.jsTagTypeFormControl.value];
    if (selectedMacrosList) {
      this.macrosListJsControl.patchValue(selectedMacrosList);
    }
  }

  private constructJsDataEndpoint(connectionType: number, dspList: number[]): any {
    return {
      ...this.formValue,
      endpoint: this.endpointUrl,
      connectionType: connectionType,
      iab_cat: [...this.getCheckedIABCategories()],
      secretKey: this.token,
      seat: this.seat,
      dspList: dspList,
      js: {
        ...this.jsFormGroupValue,
        macrosList: this.selectedJsMacros,
      }
    };
  }

  private createJsSSP(jsDataEndpoint: any, callback: (type: string) => void): void {
    this.mainService.createNewSSP(this.modifyReqData(removedJsFields, jsCheckboxes, jsDataEndpoint))
      .subscribe(() => {
        this.showNotificationError('success', 'success', 'success', 'The endpoint successfully generated');
        callback('created');
        this.isActive = false;
        this.newSSPForm.reset();
        this.connectionType = 'rtb';
      }, error => {
        this.isDisableSubmit = false;
        this.errorsHandlingService.handleError(error);
      });
  }

  private get isShowPartnerNameForPrebid(): boolean {
    return this._isShowPartnerNameForPrebid;
  }

  private set isShowPartnerNameForPrebid(value: boolean) {
    this._isShowPartnerNameForPrebid = value;
  }

  private get isShowPartnerNameForPrebidJS(): boolean {
    return this._isShowPartnerNameForPrebidJS;
  }

  private set isShowPartnerNameForPrebidJS(value: boolean) {
    this._isShowPartnerNameForPrebidJS = value;
  }

  private get jsFormGroupValue() {
    return this.newSSPForm.get('js')?.value;
  }

  private get jsTagTypeFormControl(): FormControl {
    return this.newSSPForm.get('js')?.get('tagType') as FormControl;
  }

  private get macrosListJsControl(): FormControl {
    return this.newSSPForm.get('js')?.get('macrosList') as FormControl;
  }

  private get pixalatePreBidSettingsControls(): { [key: string]: FormControl } {
    return (this.newSSPForm.get('pixalate_pb_settings') as FormGroup).controls as { [key: string]: FormControl };
  }

  private get vastFormGroupValue() {
    return this.newSSPForm.get('vast')?.value;
  }

  private get vastFormGroup() {
    return this.newSSPForm.get('vast');
  }

  private get jsWidthControl(): FormControl {
    return this.newSSPForm.get('js')?.get('w') as FormControl;
  }

  private get jsHeightControl(): FormControl {
    return this.newSSPForm.get('js')?.get('h') as FormControl;
  }

  private validateMultiAdResponses(errorMessages: string[]): string[] {
    if (this.formControls['is_multi_ad_response']?.value) {
      const multiAdControl = this.newSSPForm.get('multi_ad_responses');
      if (multiAdControl?.value === null || multiAdControl?.value === undefined || multiAdControl?.value === '') {
        errorMessages.push('Maximum Bids per response is required when Multi-bid response logic is enabled');
        multiAdControl?.setErrors({ invalid: true });
      } else if (multiAdControl?.invalid) {
        errorMessages.push('Maximum Bids per response must be between 2 and 10');
      }
    }
    return errorMessages;
  }

  private showNotificationError(iconType: string, color: string, notificationType: string, description: string): void {
    const data = {
      iconType,
      color,
      notificationType,
      description,
    };
    this.notificationComponent.data = data;
    this.notificationService.showTemplate({ nzData: data });
  }

  private getCompaniesNames(): void {
    this.mainService.getCompaniesNames(this.companyFilter)
      .subscribe((resp) => {
        this.companies = [];
        this.companies = resp.data;
        this.companies.unshift({
          id: -1,
          name: '+ Create New Company',
          terms: 30
        });
      },
        error => this.errorsHandlingService.handleError(error));
  }

  private validateTrafficType(errors: string[]): string[] {
    if (this.isRtbConnection() || this.isPrebidJsConnection() || this.isPreBidConnection()) {
      errors = this.validateFormControlsTrafficType(errors);
    }

    if (this.isVastConnection()) {
      errors = this.validateAdTypeControlValue(errors);
    }

    return errors;
  }

  private validateFormControlsTrafficType(errors: string[]): string[] {
    const checkedAtLeastOneType = this.formControls.mobile_web.value || this.formControls.desktop.value ||
      this.formControls.mobile_app.value || this.formControls.ctv.value;
    return this.updateTrafficTypeValidation(checkedAtLeastOneType, errors);
  }

  private validateAdTypeControlValue(errors: string[]): string[] {
    const checkedAtLeastOneType = ['mobile_web', 'mobile_app', 'desktop', 'ctv'].includes(this.adTypeControlValue);
    return this.updateTrafficTypeValidation(checkedAtLeastOneType, errors);
  }

  private updateTrafficTypeValidation(checkedAtLeastOneType: boolean, errors: string[]): string[] {
    if (!checkedAtLeastOneType) {
      this.isRequiredTrafficType = true;
      errors.push('Please select at least one traffic type.');
    } else {
      this.isRequiredTrafficType = false;
    }
    return errors;
  }

  private handleErrors() {
    this.markFormControlsAsTouched();
    let errorMessages: string[] = [];

    errorMessages = this.collectValidationErrors(errorMessages);

    if (errorMessages.length) {
      this.displayErrorMessages(errorMessages);
      return false;
    }

    return true;
  }

  private markFormControlsAsTouched() {
    const touchControls = ['region', 'companyId', 'newCompanyName', 'bidfloor', 'jsBidfloor', 'name', 'h'];
    touchControls.forEach(control => {
      if (this.formControls[control]) {
        this.formControls[control].markAsTouched();
      }
    });

    if (this.formControls.margin_type.value === 'fixed') {
      this.newSSPForm.controls['margin'].markAsTouched();
    }

    if (this.formControls.margin_type.value === 'range') {
      this.newSSPForm.controls['min_margin'].markAsTouched();
      this.newSSPForm.controls['max_margin'].markAsTouched();
    }

    if (this.newSSPForm.controls['w']) {
      this.newSSPForm.controls['w'].markAsTouched();
    }

    if (this.formControls['is_multi_ad_response']?.value) {
      this.newSSPForm.controls['multi_ad_responses'].markAsTouched();
    }
  }

  private collectValidationErrors(errorMessages: string[]): string[] {
    errorMessages = this.validateTrafficType(errorMessages);
    errorMessages = this.validateAdFormat(errorMessages);
    errorMessages = this.validateCompany(errorMessages);
    errorMessages = this.validateRegion(errorMessages);
    errorMessages = this.validateMargin(errorMessages, this.arrayOfMargins);
    errorMessages = this.validateName(errorMessages);

    if (this.isRtbConnection()) {
      errorMessages = this.validateCustomAdapterHuawei(errorMessages);
    }

    if (this.isJSConnection()) {
      errorMessages = this.validateBidFloor(errorMessages);
      errorMessages = this.validateSpendLimit(errorMessages);
      errorMessages = this.validateJsHeight(errorMessages);
      errorMessages = this.validateJsWidth(errorMessages);
    }

    if (this.isVastConnection()) {
      errorMessages = this.validateVastBidfloor(errorMessages);
      errorMessages = this.validateMidRollStartDelay(errorMessages);
      errorMessages = this.validateVastEnhancementFields(errorMessages);
      errorMessages = this.validateSkipMin(errorMessages);
      errorMessages = this.validateSkipAfter(errorMessages);
    }

    errorMessages = this.validateMacrosRequirement(errorMessages);
    errorMessages = this.validateRequiredFields(errorMessages);
    errorMessages = this.validateMultiAdResponses(errorMessages);

    return errorMessages;
  }

  private validateVastEnhancementFields(errors: string[]): string[] {
    const vastControls = this.formControls['vast'];

    const controlKeys = [
      'minduration',
      'maxduration',
    ];

    const controlNames = {
      minduration: 'Min Duration',
      maxduration: 'Max Duration',
    };

    controlKeys.forEach(controlKey => {
      if (vastControls.get(controlKey)?.value === null) {
        errors.push(`${controlNames[controlKey]} is required`);
      }

      if (vastControls.get(controlKey)?.value !== null && vastControls.get(controlKey)?.value < 0) {
        errors.push(`${controlNames[controlKey]} cannot be less than 0`);
      }
    });

    return errors;
  }

  private validateSkipMin(errors: string[]): string[] {
    const skipMinControl = this.newSSPForm.get('vast')?.get('skipmin');
    const skiipControl = this.newSSPForm.get('vast')?.get('skip');

    if (skiipControl?.value === 1) {
      if (skipMinControl?.value === null) {
        errors.push('Skip Min is required');
      }

      if (skipMinControl?.value !== null && skipMinControl?.value < 0) {
        errors.push('Skip Min cannot be less than 0');
      }
    }

    return errors;
  }

  private validateSkipAfter(errors: string[]): string[] {
    const skipAfterControl = this.newSSPForm.get('vast')?.get('skipafter');
    const skiipControl = this.newSSPForm.get('vast')?.get('skip');

    if (skiipControl?.value === 1) {
      if (skipAfterControl?.value === null) {
        errors.push('Skip After is required');
      }

      if (skipAfterControl?.value !== null && skipAfterControl?.value < 0) {
        errors.push('Skip After cannot be less than 0');
      }
    }

    return errors;
  }

  private validateMidRollStartDelay(errors: string[]): string[] {
    const startdelaymidControl = this.newSSPForm.get('vast')?.get('startdelaymid');

    if (this.newSSPForm.get('vast')?.get('startdelay')?.value !== 1) {
      return errors;
    }

    if (startdelaymidControl?.value === null) {
      errors.push('Mid-roll start delay is required');
    }

    if (startdelaymidControl?.value !== null && startdelaymidControl?.value < 1) {
      errors.push('Mid-roll start delay cannot be less than 1');
    }

    if (startdelaymidControl?.value !== null && startdelaymidControl?.value > 3000) {
      errors.push('Mid-roll start delay cannot be greater than 3000');
    }

    return errors;
  }

  private validateCustomAdapterHuawei(errorMessages: string[]): string[] {
    if (!this.isOnlyNativeSelected() && this.selectedAdapterName === 'Huawei') {
      errorMessages.push('The endpoint could not be generated because Huawei adaptor works only with the Native ad format. Please make the necessary changes');
    }

    return errorMessages;
  }

  private validateMacrosRequirement(errorMessages: string[]): string[] {
    if (!this.validateRequiredMacros()) {
      if (['mobile_web', 'desktop'].includes(this.adTypeControlValue)) {
        errorMessages.push('At least one macros of [PAGE_URL], [DOMAIN] is required');
      }

      if (['mobile_app', 'ctv'].includes(this.adTypeControlValue)) {
        errorMessages.push('macros [APP_BUNDLE] is required');
      }
    }
    return errorMessages;
  }

  private validateRequiredFields(errorMessages: string[]): string[] {
    const requiredFields = this.requiredFields;
    for (const i in requiredFields) {
      if (this.formControls[i] && this.formControls[i].status === 'INVALID') {
        errorMessages.push(`${requiredFields[i]} is required`);
      }
    }
    return errorMessages;
  }

  private validateJsHeight(errors: string[]): string[] {
    if (!this.formValue.js.h && this.isJSConnection()) {
      errors.push('Height is required');
      this.newSSPForm.get('js')?.get('h')?.setErrors({ invalid: true });
      this.newSSPForm.get('js')?.get('h')?.markAsTouched();
    }
    return errors;
  }

  private validateSpendLimit(errors: string[]): string[] {
    if (!this.formValue.spendLimit) {
      errors.push('Spend Limit is required');
    }
    return errors;
  }

  private validateJsWidth(errors: string[]): string[] {
    if (!this.formValue.js.w && this.isJSConnection()) {
      errors.push('Width is required');
      this.newSSPForm.get('js')?.get('w')?.setErrors({ invalid: true });
      this.newSSPForm.get('js')?.get('w')?.markAsTouched();
    }
    return errors;
  }

  private validateCompany(errors: string[]): string[] {
    this.isRequiredCompany = !this.formControls.companyId.value;
    if (this.isRequiredCompany) {
      errors.push('Company is required');
    }

    return errors;
  }

  private validateRegion(errors: string[]): string[] {
    this.isRequiredRegion = !this.formControls.region.value;
    if (this.isRequiredRegion) {
      errors.push('Region is required');
    }

    return errors;
  }

  private validateAdFormat(errors: string[]): string[] {
    if (this.requiresAdFormatValidation()) {
      const checkedAtLeastOneFormat = this.hasSelectedAtLeastOneAdFormat();
      errors = this.updateAdFormatValidation(checkedAtLeastOneFormat, errors);
    }

    return errors;
  }

  private requiresAdFormatValidation(): boolean {
    return this.isRtbConnection() || this.isVastConnection() || this.isPreBidConnection() || this.isPrebidJsConnection();
  }

  private hasSelectedAtLeastOneAdFormat(): boolean {
    const adFormatKeys = ['isBanner', 'isNative', 'isVideo', 'rewarded', 'isAudio'];
    return adFormatKeys.some(key => this.formControls[key].value);
  }

  private updateAdFormatValidation(checkedAtLeastOneFormat: boolean, errors: string[]): string[] {
    this.isRequiredAdFormat = !checkedAtLeastOneFormat;
    if (!checkedAtLeastOneFormat) {
      errors.push('Please select at least one ad format.');
    }
    return errors;
  }

  private validateBidFloor(errors: string[]): string[] {
    const bidFloor = this.jsFormGroupValue.bidfloor;

    if (!bidFloor) {
      errors.push('Fixed Bidfloor is required');
    }

    if (bidFloor < 0) {
      errors.push('The minimal Fixed Bidfloor value cannot be less than 0');
    }

    return errors;
  }

  private validateVastBidfloor(errors: string[]): string[] {
    const bidFloor = this.vastFormGroupValue.bidfloor;

    if (!bidFloor) {
      errors.push('Fixed Bidfloor is required');
    }

    if (bidFloor < 0.01) {
      errors.push('The minimal Fixed Bidfloor value cannot be less than 0.01');
    }

    return errors;
  }

  private validateMargin(errors: string[], arrayOfMargins: { key: string, minValue: number, maxValue: number }[]): string[] {
    this.validateMarginRange(errors);
    this.validateIndividualMargins(errors, arrayOfMargins);
    return errors;
  }

  private validateMarginRange(errors: string[]): void {
    if (this.formControls.margin_type.value === 'range') {
      const minMargin = this.formControls.min_margin.value;
      const maxMargin = this.formControls.max_margin.value;
      if (minMargin >= maxMargin && (minMargin !== null || maxMargin !== null)) {
        this.setMarginErrors();
        errors.push('Maximum margin value must be greater than minimum margin value');
      }
    }
  }

  private setMarginErrors(): void {
    this.formControls['min_margin'].setErrors({ invalid: true });
    this.formControls['max_margin'].setErrors({ invalid: true });
  }

  private validateIndividualMargins(errors: string[], arrayOfMargins: { key: string, minValue: number, maxValue: number }[]): void {
    arrayOfMargins.forEach(margin => {
      this.validateMarginValue(margin, errors);
    });
  }

  private validateMarginValue(margin: { key: string, minValue: number, maxValue: number }, errors: string[]): void {
    const value = this.formControls[margin.key].value;
    if (value === null || value === undefined) {
      errors.push(`${this.marginKeys[margin.key]} is required`);
    } else {
      if (value < margin.minValue) {
        errors.push(`${this.marginKeys[margin.key]} value must not be lower than ${margin.minValue}`);
      }
      if (value > margin.maxValue) {
        errors.push(`${this.marginKeys[margin.key]} value must not be higher than ${margin.maxValue}`);
      }
    }
  }

  private validateRequiredMacros(): boolean {
    if (!this.isVastConnection() || this.vastFormGroupValue['adServerId'] != null) {
      return true;
    }

    return this.vast.macrosList.some(macro => this.requiredMacros[this.adTypeControlValue].includes(macro));
  }

  private validateName(errors: string[]): string[] {
    const { name } = this.newSSPForm.controls;
    if (name.errors?.maxlength) {
      const { requiredLength, actualLength } = name.errors.maxlength;
      errors.push(`You have reached your maximum limit of characters allowed. Required length is ${requiredLength}, but you entered ${actualLength}`);
    }

    if (name.errors?.required) {
      errors.push('Name is required');
    }

    return errors;
  }

  private getMandatoryMarcoses() {
    if (!this.isJSConnection()) return [];

    const tagType = this.jsTagTypeFormControl.value;
    const webTypes = ['web', 'serverWeb'];
    const appTypes = ['app', 'serverApp'];
    const noMacrosTypes = ['googleAd', 'mobup'];

    if (webTypes.includes(tagType)) {
      return ['[IP]', '[UA]', '[DOMAIN]', '[PAGE_URL]'];
    } else if (appTypes.includes(tagType)) {
      return ['[IP]', '[UA]', '[IFA]'];
    } else if (noMacrosTypes.includes(tagType)) {
      return [];
    }

    return [];
  }

  private getCheckedBlockedIABCategories(): string[] {
    const processElement = (element: HelpersInterface.ITressSelectItem): string[] =>
      element.checked ? [element.key, ...element.children?.flatMap(processElement) || []] : element.children?.flatMap(processElement) || [];

    return this.iabBlockedCategories.flatMap(processElement);
  }

  private getCheckedIABCategories(): string[] {
    const processElement = (element: HelpersInterface.ITressSelectItem): string[] =>
      element.checked ? [element.key, ...element.children?.flatMap(processElement) || []] : element.children?.flatMap(processElement) || [];

    return this.iabCategories.flatMap(processElement);
  }

  private isOnlyNativeSelected(): boolean {
    const {
      isBanner,
      isNative,
      isVideo,
      rewarded,
      isAudio
    } = this.newSSPForm.value;
    return isNative && !isBanner && !isVideo && !rewarded && !isAudio;
  }

  private onSetHuaweiAdapterByAdFormat(): void {
    let huaweiAdapter = this.rtbAdapters.find(adapter => adapter.name === 'Huawei');
    if (huaweiAdapter) {
      if (this.isOnlyNativeSelected()) {
        huaweiAdapter.disabled = false;
      } else {
        huaweiAdapter.disabled = true;
      }
    }
  }

  private setEndpointRegion(): void {
    const regionId = this.regions.find(region => region.id === 'US_EAST')?.id || this.regions[0].id;
    this.formControls['region'].patchValue(regionId);
  }

  private setPartnerDomain(): void {
    for (const domain of this.partnerSettings?.domains || []) {
      if (domain.region === 'US_EAST') {
        this.partnerSettings.ns = domain.ns;
        break;
      } else {
        this.partnerSettings.ns = domain.ns;
      }
    }
  }

  private setProtocolAndURL(): void {
    if (this.partnerSettings.useSsl) {
      this.protocol = 'https://';
    } else {
      this.protocol = 'http://';
    }
    this.url = this.protocol + this.partnerSettings.ns + '/?c=rtb&m=js&type=s2c' + '&seat=' + this.seat + '&token=' + this.token;
  }

  private getVastMacroses(): void {
    this.listOfMacros = [];
    this.listOfMacros = this.macrosListVast.map(macros => macros);
    this.listOfMacros.push(
      {
        id: '[IP]',
        name: '[IP]',
        mobile_web: false,
        desktop: false,
        mobile_app: false,
        ctv: false,
        desc: 'IPv4 address closest to device',
      },
    );
    this.listOfMacros.push(
      {
        id: '[UA]',
        name: '[UA]',
        mobile_web: false,
        desktop: false,
        mobile_app: false,
        ctv: false,
        desc: 'Browser user agent string.',
      },
    );
  }

  private setSelectedMacrosList(): void {
    if (this.selectedServer === null) {
      this.processMacrosListVast();
    } else {
      this.processAdServerMacroses();
    }
  }

  private processMacrosListVast(): void {
    const { selectedMacros } = this.macrosListVast.reduce<{ selectedMacros: string[], macroses: any[] }>((acc, item) => {
      if (item[this.adTypeControlValue]) {
        acc.macroses.push(item);
        acc.selectedMacros.push(item.id);
      }
      return acc;
    }, { selectedMacros: [], macroses: [] });

    this.listOfMacros = this.macrosListVast.map(macros => macros);
    this.vast.macrosList = selectedMacros;
  }

  private processAdServerMacroses(): void {
    this.macrosListVast = [];
    const selectedMacros: string[] = [];

    Object.values(this.adServerMacroses).forEach(macrosItem => {
      if (macrosItem[this.adTypeControlValue] === 1) {
        const macros = macrosItem.showAttr === 0 ? macrosItem.macros : macrosItem.shortcut;
        this.macrosListVast.push(this.createMacrosObject(macrosItem, macros));
        this.urlVastAttributes[macros] = macrosItem.shortcut;
        selectedMacros.push(macros);
      }
    });

    this.vast.macrosList = selectedMacros;
  }

  private createMacrosObject(macrosItem, macros): any {
    return {
      id: macros,
      name: macros,
      mobile_web: macrosItem.mobile_web,
      desktop: macrosItem.desktop,
      mobile_app: macrosItem.mobile_app,
      ctv: macrosItem.ctv,
      desc: '',
    };
  }

  private setShowStatusForPartnerName(): void {
    if (this.partnerSettings.prebidIntegration) {
      const { wl_prebid, wl_prebid_time, js_prebid, js_prebid_time } = this.partnerSettings.prebidIntegration;

      this.isShowPartnerNameForPrebid = !Boolean(wl_prebid && !!wl_prebid_time);
      this.isShowPartnerNameForPrebidJS = !Boolean(js_prebid && !!js_prebid_time);
    }

  }

  private setJSMacrosList(): void {
    const macrosMap = {
      web: this.macrosListScriptWeb,
      app: this.macrosListApp,
      serverApp: this.macrosListApp,
      serverWeb: this.macrosListServerWeb,
      googleAd: this.macrosListGoogleAds,
      mobup: this.macrosListMobup,
    };

    this.macrosListJs = macrosMap[this.jsTagTypeFormControl.value] || this.macrosListJs;
  }

  private setInitSelectedMacrosList(): void {
    this.vast.macrosList = this.macrosListVast.filter(macros => macros.mobile_web).map(macros => macros['id']);
  }

  private modifyReqData(removedFields: string[], checkboxes: string[], reqObject: { [key: string]: any }): { [key: string]: any } {
    let requestBody: { [key: string]: any } = {};
    for (const key of Object.keys(reqObject)) {
      if (key !== 'adapter_config') {
        if (removedFields.includes(key) || reqObject[key] === null || reqObject[key] === undefined) {
          delete reqObject[key];
          continue;
        }
      }

      if (checkboxes.includes(key)) {
        reqObject[key] = reqObject[key] ? 1 : 0;
        continue;
      }

      if (key === 'pixalate_pb_settings' && typeof reqObject[key] === 'object') {
        for (const innerKey of Object.keys(reqObject[key])) {
          if (checkboxes.includes(innerKey)) {
            const innerValue = reqObject[key][innerKey];
            reqObject[key][innerKey] = innerValue ? 1 : 0;
          }
        }
      }
    }

    requestBody = { ...reqObject };

    return requestBody;
  }

  private getSSPAdapters(): void {
    this.mainService.getAdaptersByType({ is_prebid: false, type: 'ssp' })
      .subscribe({
        next: (res) => {
          const fieldsNone = {
            name: 'None',
            id: 0,
            fields: [],
            config: {},
          };
          this.rtbServers = [fieldsNone, ...res.map(item => ({
            ...item,
            name: item.name === 'Rubicon' && !this.partnerSettings.has_rubicon_settings ? 'Rubicon Inactive' : item.name
          }))];
          this.rtbAdapters = this.rtbServers.map(({ id, name, config }) => ({ id, name, config, disabled: false }));
          let huaweiAdapter = this.rtbAdapters.find(adapter => adapter.name === 'Huawei');
          if (huaweiAdapter) huaweiAdapter.disabled = true;
        },
        error: (error) => this.errorsHandlingService.handleError(error)
      });
  }

  private getSeatAndTokenForJsTag(): void {
    this.mainService.getSeatAndTokenForSspEndpoint()
      .subscribe(resp => {
        this.seat = resp.seat;
        this.token = resp.token;
      },
        error => this.errorsHandlingService.handleError(error));
  }

  private getAdServers(): void {
    this.mainService.getAdServers()
      .subscribe({
        next: (resp) => {
          this.adServers = resp.data;
          this.servers = this.adServers
            .filter((item: any) => item.adTypes[this.adTypeControlValue])
            .map(({ id, name }) => ({ id, name }));
        },
        error: (error) => this.errorsHandlingService.handleError(error)
      });
  }

  private getIABCategories(): void {
    this.mainService.getFilterValuesByKeyReq({ filters: ['iabCategories'] })
      .subscribe(res => {
        this.iabBlockedCategories = JSON.parse(JSON.stringify(res.iabCategories));
        this.iabCategories = JSON.parse(JSON.stringify(res.iabCategories));
      },
        error => this.errorsHandlingService.handleError(error));
  }

  private displayErrorMessages(errorMessages: string[]): void {
    errorMessages.forEach(errorMessage => {
      this.showNotificationError('error', 'error', 'error', errorMessage);
    });
  }

  private getDSPEndpoints(): void {
    this.mainService.getEndpointItemsReq()
      .subscribe(data => {
        this.dspList = data.dsp;
      },
        error => this.errorsHandlingService.handleError(error));
  }

  private getCompaniesForDropdowns(region: string): void {
    this.getCompaniesForDropdownsReq(region).subscribe(res => {
      this.companiesDSPDropdown = transformArray(res.dsp);
    },
      error => this.errorsHandlingService.handleError(error));
  }

  private getCompaniesForDropdownsReq(region: string): Observable<MainDashboardInterface.CompaniesDataRes> {
    const params = new HttpParams().append('without_deleted', true);

    return this.http.get<MainDashboardInterface.CompaniesDataRes>(`${this.apiUrl}/endpoints/grouped-by-company/dsp/${region}`, { params: params })
      .pipe(map(res => {
        res.dsp = res.dsp.map(company => {
          company.endpoints = company.endpoints.map(endpoint => {
            return { checked: false, disabled: false, label: endpoint.name, value: endpoint.id, ...endpoint };
          });
          return { checked: false, label: company.name, value: company.id, indeterminate: false, ...company };
        });

        return res;
      }),
        catchError(this.errorsHandlingService.processError));
  }

  private removeNonEnterpriseFields(vastDataEndpoint: any): void {
    if (this.partner.partner_plan !== 1) {
      const controlKeys = [
        'is_rewarded',
        'skip',
        'skipmin',
        'skipafter',
        'minduration',
        'maxduration',
        'startdelay',
        'placement',
        'plcmt',
        'mimes',
        'pos',
        'playbackmethod',
        'startdelaymid',
        'protocols',
        'api'
      ];

      controlKeys.forEach(controlKey => {
        delete vastDataEndpoint.vast[controlKey];
      });
    }

    return vastDataEndpoint;
  }

  private updateControlsBasedOnPartnerPlan(): void {
    const vastControls = this.formControls['vast'];

    if (!vastControls) {
      return;
    }

    const controlKeys = [
      'is_rewarded',
      'skip',
      'skipmin',
      'skipafter',
      'minduration',
      'maxduration',
      'startdelay',
      'placement',
      'plcmt',
      'mimes',
      'pos',
      'playbackmethod',
      'protocols',
      'api'
    ];

    const isActiveOneFormat = this.formValue['rewarded'] || this.formValue['isVideo'] || this.formValue['isAudio'];

    const isEnterprisePlan = this.partner?.partner_plan === 1;

    controlKeys.forEach(controlKey => {
      const control = vastControls.get(controlKey) as FormControl;

      if (!control) {
        return;
      }

      if (isEnterprisePlan) {
        control.enable({ emitEvent: false });
      } else {
        control.disable({ emitEvent: false });
        return;
      }

      if (!isActiveOneFormat) {
        control.disable({ emitEvent: false });
      } else {
        control.enable({ emitEvent: false });
      }
    });

    if (!isEnterprisePlan) {
      return;
    }

    const defaultValuesForNonEnterprisePlan: { [key: string]: any } = {
      is_rewarded: false,
      skip: 0,
      skipmin: null,
      skipafter: null,
      minduration: null,
      maxduration: null,
      startdelay: null,
      placement: null,
      plcmt: null,
      mimes: [],
      pos: null,
      playbackmethod: [],
      protocols: [],
      api: []
    };

    const defaultValuesForEnterprisePlan: { [key: string]: any } = {
      is_rewarded: false,
      skip: 0,
      skipmin: 0,
      skipafter: 0,
      minduration: 3,
      maxduration: 300,
      startdelay: null,
      placement: null,
      plcmt: null,
      mimes: ['video/mp4', 'video/mpeg', 'video/ogg', 'video/webm', 'application/javascript'],
      pos: 1,
      playbackmethod: [],
      protocols: [2, 3, 5, 6, 7, 8, 11, 12, 13, 14, 15, 16],
      api: []
    };

    const valuesToApply = isEnterprisePlan ? defaultValuesForEnterprisePlan : defaultValuesForNonEnterprisePlan;

    const enabledAudioControl = [
      'minduration',
      'maxduration',
      'mimes',
      'protocols',
      'api'
    ];

    Object.entries(valuesToApply).forEach(([controlKey, value]) => {
      const control = vastControls.get(controlKey) as FormControl;

      if (control) {
        control.patchValue(value, { emitEvent: false });
      }
    });

    if (!this.formValue['rewarded']) {
      vastControls.get('is_rewarded')?.disable({ emitEvent: false });
    } else {
      vastControls.get('is_rewarded')?.enable({ emitEvent: false });
    }

    if (this.formValue['isAudio']) {
      controlKeys.forEach(controlKey => {
        vastControls.get(controlKey)?.disable({ emitEvent: false });
      });

      enabledAudioControl.forEach(control => {
        vastControls.get(control)?.enable({ emitEvent: false });
        vastControls.get('mimes')?.patchValue(['audio/mp4']);
      });
    }
  }
}
